<template>
  <a-modal
    title="编辑结账管理（体检）"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false"><a-input v-decorator="['id']" /></a-form-item>
        <a-form-item
          label="账单周期（ex:2023-01）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入账单周期（ex:2023-01）" v-decorator="['billCycle', {rules: [{required: true, message: '请输入账单周期（ex:2023-01）！'}]}]" />
        </a-form-item>
        <a-form-item
          label="结账人"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入结账人" v-decorator="['checkoutUser', {rules: [{required: true, message: '请输入结账人！'}]}]" />
        </a-form-item>
        <a-form-item
          label="结账日期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择结账日期" v-decorator="['checkoutDate',{rules: [{ required: true, message: '请选择结账日期！' }]}]" @change="onChangecheckoutDate"/>
        </a-form-item>
        <a-form-item
          label="收费（分）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入收费（分）" v-decorator="['chargeFee', {rules: [{required: true, message: '请输入收费（分）！'}]}]" />
        </a-form-item>
        <a-form-item
          label="退款（分）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入退款（分）" v-decorator="['refundFee', {rules: [{required: true, message: '请输入退款（分）！'}]}]" />
        </a-form-item>
        <a-form-item
          label="删除标识（0-否1-是）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入删除标识（0-否1-是）" v-decorator="['deleteFlag', {rules: [{required: true, message: '请输入删除标识（0-否1-是）！'}]}]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import moment from 'moment'
  import { baCheckoutExamEdit } from '@/api/modular/interhospital/bacheckoutexam/baCheckoutExamManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        checkoutDateDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      moment,
      // 初始化方法
      edit (record) {
        this.visible = true
        setTimeout(() => {
          this.form.setFieldsValue(
            {
              id: record.id,
              billCycle: record.billCycle,
              checkoutUser: record.checkoutUser,
              chargeFee: record.chargeFee,
              refundFee: record.refundFee,
              deleteFlag: record.deleteFlag
            }
          )
        }, 100)
        // 时间单独处理
        if (record.checkoutDate != null) {
            this.form.getFieldDecorator('checkoutDate', { initialValue: moment(record.checkoutDate, 'YYYY-MM-DD') })
        }
        this.checkoutDateDateString = moment(record.checkoutDate).format('YYYY-MM-DD')
      },
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            values.checkoutDate = this.checkoutDateDateString
            baCheckoutExamEdit(values).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('编辑失败')//  + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangecheckoutDate(date, dateString) {
        this.checkoutDateDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
